import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const specialties = [{
  label: 'Vasculitis',
  icon: <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-539">
        <circle cx="10" cy="10" r="9" stroke="#DC2626" strokeWidth="2" data-id="element-540" />
        <circle cx="10" cy="10" r="4" fill="#DC2626" data-id="element-541" />
      </svg>
}, {
  label: 'Peripheral artery disease',
  icon: <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-542">
        <path d="M10 3C10 3 4 7.5 4 11.5C4 14.5 6.7 17 10 17C13.3 17 16 14.5 16 11.5C16 7.5 10 3 10 3Z" fill="#DC2626" data-id="element-543" />
      </svg>
}, {
  label: 'Autoimmune circulatory disorders',
  icon: <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-544">
        <path d="M10 2C10 2 7 4 7 6C7 7.1 7.9 8 9 8H11C12.1 8 13 7.1 13 6C13 4 10 2 10 2Z" fill="#7C3AED" data-id="element-545" />
        <path d="M6 9C4.9 9 4 9.9 4 11V13C4 14.1 4.9 15 6 15H14C15.1 15 16 14.1 16 13V11C16 9.9 15.1 9 14 9H6Z" fill="#7C3AED" opacity="0.7" data-id="element-546" />
        <path d="M8 15V18M12 15V18" stroke="#7C3AED" strokeWidth="1.5" strokeLinecap="round" data-id="element-547" />
      </svg>
}, {
  label: 'Chronic inflammatory syndromes',
  icon: <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-548">
        <path d="M10 2V6M10 14V18M2 10H6M14 10H18" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" data-id="element-549" />
        <circle cx="10" cy="10" r="3" fill="#DC2626" opacity="0.3" data-id="element-550" />
        <circle cx="10" cy="10" r="1.5" fill="#DC2626" data-id="element-551" />
      </svg>
}];
export function DoctorBioSection() {
  return <section className="py-10 sm:py-14 bg-[#F8F6F3]" data-id="element-552">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-553">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} data-id="element-554">
          {/* Doctor Image */}
          <div className="flex justify-center mb-6 sm:mb-8" data-id="element-555">
            <div className="w-48 h-48 sm:w-56 sm:h-56 rounded-2xl overflow-hidden shadow-lg border-2 border-white" data-id="element-556">
              <img src="https://cdn.magicpatterns.com/uploads/wwxCNf5ASPQRb3j31WqHvw/DOCOTR_G.png" alt="Dr. Marcus Ellwood, MD, PhD" className="w-full h-full object-cover object-top" loading="lazy" decoding="async" width="400" height="400" data-id="element-557" />
            </div>
          </div>

          {/* Name & Title */}
          <div className="text-center mb-6 sm:mb-8" data-id="element-558">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1A1A1A] tracking-tight mb-1" data-id="element-559">
              Dr. Marcus Ellwood, MD, PhD
            </h2>
            <p className="text-sm sm:text-base text-ginger font-semibold tracking-wide" data-id="element-560">
              Specialist in Inflammatory & Circulatory Medicine
            </p>
          </div>

          {/* Bio Content */}
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-[#E8E2DA]" data-id="element-561">
            <div className="space-y-4 text-sm sm:text-base text-[#3D3D3D] leading-relaxed" data-id="element-562">
              <p data-id="element-563">
                Dr. Marcus Ellwood is a board-certified physician specializing
                in inflammatory diseases and circulatory disorders, with over 18
                years of clinical and research experience. He completed his
                medical degree at{' '}
                <strong className="text-[#1A1A1A]" data-id="element-564">
                  Johns Hopkins University School of Medicine
                </strong>
                , followed by a PhD in Vascular Biology at{' '}
                <strong className="text-[#1A1A1A]" data-id="element-565">Stanford University</strong>.
              </p>

              <p data-id="element-566">
                After his residency in Internal Medicine, Dr. Ellwood pursued a
                fellowship in Rheumatology and Cardiovascular Immunology, where
                he developed a deep expertise in the connection between chronic
                inflammation and circulatory dysfunction.
              </p>

              <p data-id="element-567">
                He currently serves as{' '}
                <strong className="text-[#1A1A1A]" data-id="element-568">
                  Director of the Vascular Inflammation Clinic at Northwestern
                  Medical Center
                </strong>
                , where he treats patients suffering from conditions such as:
              </p>

              {/* Specialties List */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 py-2" data-id="element-569">
                {specialties.map((item, i) => <div key={i} className="flex items-center gap-3 bg-[#FAF7F2] border border-[#E8E2DA] rounded-lg px-4 py-3" data-id="element-570">
                    {item.icon}
                    <span className="text-sm font-medium text-[#2D2D2D]" data-id="element-571">
                      {item.label}
                    </span>
                  </div>)}
              </div>

              <p data-id="element-572">
                Dr. Ellwood has published over{' '}
                <strong className="text-[#1A1A1A]" data-id="element-573">
                  60 peer-reviewed articles
                </strong>{' '}
                and is a sought-after speaker at international medical
                conferences. He is also a passionate advocate for early
                diagnosis and integrative treatment approaches.
              </p>
            </div>

            {/* Quote */}
            <div className="mt-6 pt-6 border-t border-[#E8E2DA]" data-id="element-574">
              <div className="flex gap-3 sm:gap-4" data-id="element-575">
                {/* Quote Icon */}
                <svg className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0 text-ginger/30" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-576">
                  <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z" data-id="element-577" />
                </svg>
                <div data-id="element-578">
                  <p className="text-base sm:text-lg italic text-[#2D2D2D] leading-relaxed font-medium" data-id="element-579">
                    Inflammation is often the silent driver behind our most
                    complex circulatory conditions. Finding it early changes
                    everything.
                  </p>
                  <p className="mt-2 text-sm font-semibold text-ginger" data-id="element-580">
                    — Dr. Marcus Ellwood
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}